export const STATUSES_STATE_SLICE = '@cld_statuses';
export const STATUS_ACTION_TYPE = 'STATUS_ACTION';
export const RESET_ACTION_TYPE = 'RESET_ACTION';
